// Password Screen - Full-Width Responsive Layout
import { useState } from 'react';
import { Container, Text, Button, Card } from '../components/ui';

function PasswordScreen({ onAuthenticated }) {
    const [username, setUsername] = useState(localStorage.getItem('app_username') || '');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            const isValid = await validateCredentials(username, password);
            if (isValid) {
                localStorage.setItem('app_username', username);
                localStorage.setItem('app_password', password);
                onAuthenticated();
            } else {
                setError('Tên đăng nhập hoặc mật khẩu không đúng');
            }
        } catch (err) {
            setError('Lỗi xác thực: ' + err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container className="min-h-screen flex flex-col items-center justify-center bg-theme-bg" safe>
            <div className="main-content flex flex-col items-center">
                {/* Logo */}
                <div className="relative w-24 h-24 mb-8">
                    <div className="absolute inset-0 bg-primary/20 rounded-3xl animate-pulse" />
                    <div className="absolute inset-2 bg-gradient-to-br from-primary to-primary-light rounded-2xl flex items-center justify-center">
                        <span className="text-3xl">🔐</span>
                    </div>
                </div>

                <Text variant="h2" className="mb-2">Thiệt Chuẩn AI</Text>
                <Text variant="caption" className="mb-8 text-center max-w-xs">
                    Đăng nhập để truy cập ứng dụng
                </Text>

                <Card className="w-full max-w-xs">
                    <form onSubmit={handleSubmit} className="space-y-4" autoComplete="on">
                        <div>
                            <input
                                type="text"
                                name="username"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                placeholder="Tên đăng nhập"
                                className="w-full bg-theme-tertiary text-theme-primary px-4 py-3 rounded-xl text-base"
                                autoComplete="username"
                                autoFocus
                                required
                            />
                        </div>
                        <div>
                            <input
                                type="password"
                                name="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="Mật khẩu"
                                className="w-full bg-theme-tertiary text-theme-primary px-4 py-3 rounded-xl text-base"
                                autoComplete="current-password"
                                required
                            />
                        </div>

                        {error && (
                            <div className="text-danger text-sm text-center bg-danger/10 py-2 rounded-lg">
                                {error}
                            </div>
                        )}

                        <Button
                            type="submit"
                            className="w-full"
                            disabled={loading || !username || !password}
                        >
                            {loading ? 'Đang xác thực...' : 'Đăng nhập'}
                        </Button>
                    </form>
                </Card>

                <Text variant="small" className="mt-6 text-center max-w-xs">
                    Liên hệ admin nếu bạn quên mật khẩu
                </Text>
            </div>
        </Container>
    );
}

// Validate credentials - try worker first, fallback to local
async function validateCredentials(username, password) {
    const { getWorkerUrl } = await import('../config/api.config');
    const workerUrl = getWorkerUrl();

    try {
        const response = await fetch(`${workerUrl}/validate-credentials`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ username, password }),
        });

        if (response.ok) {
            const data = await response.json();
            return data.valid;
        }
    } catch (e) {
        console.warn('Worker validation failed, using local check');
    }

    // Fallback: local validation
    const LOCAL_USERNAME = 'admin';
    const LOCAL_PASSWORD = 'Th@mKha11';
    return username === LOCAL_USERNAME && password === LOCAL_PASSWORD;
}

export default PasswordScreen;
